import React, { useState } from 'react';
import RModal from '../../components/Rsuite/Modal';
import { Tag, Button, Container } from 'rsuite';
import {
  FaBell,
  FaExclamationCircle,
  FaRegEnvelope,
  FaEnvelopeOpenText
 } from 'react-icons/fa';
import * as S from './styles';
import { useWarnings } from '../../hooks/useWarnings';
import { ContentHeader } from '../../components/ContentHeader';
import { useCustomTheme } from '../../hooks/useCustomTheme';

const Avisos = () => {
  const { warnings, updateWarning } = useWarnings();
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedAviso, setSelectedAviso] = useState(null);
  const { theme } = useCustomTheme();

  const handleOpenAviso = async (aviso) => {
    setSelectedAviso(aviso);
    setModalOpen(true);

    if (aviso.Lido === 0) {
      try {
        await updateWarning(aviso);
      } catch (error) {
        console.error("Falha ao marcar aviso como lido", error);
      }
    }
  };

  const formatData = (dataString) => {
    if (!dataString) return '';
    const date = new Date(dataString);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit'
    });
  };

  return (
    <Container
      style={{
        padding: '10px',
        height: 'calc(100vh - 60px)',
        backgroundColor: theme.colors.background,
      }}
    >
      <ContentHeader
        title="Avisos"
        subtitle="Gerencie os avisos e novidades da sua empresa"
        icon={FaBell}
      />
      {!warnings.length ? (
        <S.EmptyState>
          <FaRegEnvelope size={48} />
          <h4>Caixa de entrada vazia</h4>
          <p>Você não possui nenhum aviso no momento.</p>
        </S.EmptyState>
      ) : (
        <S.NoticeList>
          {warnings.map((aviso) => (
            <S.NoticeItem
              key={aviso.Id}
              $isRead={aviso.Lido === 1}
              onClick={() => handleOpenAviso(aviso)}
            >
              <S.NoticeHeader>
                <S.NoticeTitle $isRead={aviso.Lido === 1}>
                  {aviso.Lido === 0 ? <FaRegEnvelope color="#0ea5e9" size={16}/> : <FaEnvelopeOpenText color="#94a3b8" size={16}/>}
                  {aviso.Titulo}
                  {!!aviso.Important && (
                    <Tag color="red" size="sm" style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <FaExclamationCircle /> Importante
                    </Tag>
                  )}
                </S.NoticeTitle>
                <S.NoticeDate>{formatData(aviso.CreatedAt)}</S.NoticeDate>
              </S.NoticeHeader>
              <S.NoticePreview>
                {aviso.Descricao}
              </S.NoticePreview>
            </S.NoticeItem>
          ))}
        </S.NoticeList>
      )}

      {modalOpen && <RModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        bodyStyle={{ width: '100%', maxWidth: '650px' }}
        title={<>
          {!!selectedAviso?.Important && <FaExclamationCircle color="#ef4444" style={{ marginRight: 5 }} />}
          {selectedAviso?.Titulo}
        </>}
        footer={
          <S.FooterModal>
            <S.Span>Recebido em {formatData(selectedAviso?.CreatedAt)}</S.Span>
            <Button onClick={() => setModalOpen(false)} appearance="primary">
              Entendi
            </Button>
          </S.FooterModal>
        }
      >
        <S.ContainerModal>
          {selectedAviso?.Descricao}
        </S.ContainerModal>
      </RModal>}
    </Container>
  );
};

export default Avisos;
